import React from "react"
  import {
    Container,
    Col,
    Row,
    Collapse,
    Navbar,
    NavbarToggler,
    NavbarBrand,
    Nav,
    NavItem,
    NavLink,
    UncontrolledDropdown,
    DropdownToggle,
    DropdownMenu,
    DropdownItem } from 'reactstrap';
    import logobottom from './images/logobottomarm.png';

    function Footer(){
          return (
            <Container fluid className="footer">
              <Row className="text-center">
                <Col>
                  <a href="https://aljazeera.net" target="_blank">
                    <img alt="Al Jazeera" width="257px" height="auto" src={logobottom}/>
                  </a>
                  <br/>
                  <br/>
                  <br/>
                  <p>إنتاج: محمد الحداد، يسيد صديقي، أويس زهير، د. محمد العلي، زهير حمداني، مصطفى أبو عين لـ<a href="https://twitter.com/AJLabs" target="_blank">AJLabs@</a></p>
                  <p>مصدر البيانات -<a href="https://doi.org/10.7910/DVN/LEJUQZ" target="_blank">Erik Voeten "بيانات وتحليلات التصويت في الجمعية العامة للأمم المتحدة"، دليل روتليدج للمنظمة الدولية، تحرير بوب رينالدا.</a></p>                                                                                                                                                                                            
                  <p>شبكة الجزيرة الإعلامية 2019 ©</p>
                </Col>
              </Row>
            </Container> 
          )
        }

export default Footer